<script lang="ts" setup>
import type { PropType } from 'vue';
import BadgeWrapper from '~/components/BadgeWall/BadgeWrapper.vue';
import type { BadgeVo } from '~/types/auto/oj';

defineProps({
  list: {
    type: Array as PropType<BadgeVo[]>,
    default: () => [],
  },
});
</script>

<template>
  <div class="inline-flex gap-2">
    <div v-for="item in list" :key="item.id" class="h-10 w-10">
      <BadgeWrapper
        :image="item.url"
        :video="item.video"
        :level="item.goodsAnimation"
      ></BadgeWrapper>
    </div>
  </div>
</template>

<style scoped></style>
